import { render, staticRenderFns } from "./NewCalendar.vue?vue&type=template&id=919aae56"
import script from "./NewCalendar.vue?vue&type=script&lang=js"
export * from "./NewCalendar.vue?vue&type=script&lang=js"
import style0 from "./NewCalendar.vue?vue&type=style&index=0&id=919aae56&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports